import _, { isArray, isString } from 'lodash';
import * as actionTypes from './metaAttachActionTypes';
import * as pictionUtils from '../utils/piction';
import { SearchParams } from '../utils/searchUtils';
import { SESSION_EXPIRED_MESSAGE } from '../constants/sessionStateTypes';
import { sessionExpired } from './session';
import piction from '../utils/piction';
import appConfig from '../appConfig';

export const METATAG_GROUP_EXCEPTIONS = [
  'EXIF', 'IPTC', 'XMP', 'ID3', 'AUDIO', 'FILE', 'IMAGE',
  'INTERNAL', 'VIDEO', 'SYSTEM', 'STANDARD', 'TECHNICAL', 'GENERAL',
];

export const addMetadata = metadata => ({
  type: actionTypes.META_ATTACH_ADD,
  metadata,
});

export const populateMetadata = umo => ({
  type: actionTypes.META_ATTACH_POPULATE,
  umo,
});

export const showMetaCopy = umo => ({
  type: actionTypes.META_ATTACH_COPY,
  umo,
});

export const clearMetadata = () => ({
  type: actionTypes.META_ATTACH_CLEAR,
});

export const metaAttachRequest = () => ({
  type: actionTypes.META_ATTACH_REQUEST,
});

export const metaAttachSuccess = () => ({
  type: actionTypes.META_ATTACH_SUCCESS,
});

export const metaAttachFailure = err => ({
  type: actionTypes.META_ATTACH_FAILURE,
  err,
});

export const metaAttach = (metadata, umoIDList, isReplace = false, searchParams, intl) =>
  function metaAttachDispatch(dispatch) {
    dispatch(metaAttachRequest());

    const newUMOList = isArray(umoIDList) ? umoIDList : [umoIDList];
    const newMetaList = isArray(metadata) ? metadata : [metadata];

    let searchQuery;

    if (searchParams instanceof SearchParams) {
      searchQuery = searchParams.toSearchQuery();
    } else if (isString(searchParams)) {
      searchQuery = searchParams;
    }

    const promise = pictionUtils.metaAttach(newMetaList, newUMOList, isReplace, intl, searchQuery);

    return promise
      .then((res) => {
        dispatch(metaAttachSuccess());
        return { res };
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(metaAttachFailure(err));
        }
        return err;
      });
  };

export const metaAttachGetUmoDataRequest = umoID => ({
  type: actionTypes.META_ATTACH_GET_UMO_METATAGS_REQUEST,
  umoID,
});

export const metaAttachGetUmoDataSuccess = metatags => ({
  type: actionTypes.META_ATTACH_GET_UMO_METATAGS_SUCCESS,
  metatags,
});

export const metaAttachGetUmoDataFailure = err => ({
  type: actionTypes.META_ATTACH_GET_UMO_METATAGS_FAILURE,
  err,
});

export const getUmoMetadata = umoID =>
  function getUmoMetadataDispatch(dispatch) {
    dispatch(metaAttachGetUmoDataRequest());

    return piction.getMetatags({
      UMO_ID: umoID,
      TAG_FOR_UMO_EDITED: '' }, { useJSON : true }
    )
      .then((res) => {
        dispatch(metaAttachGetUmoDataSuccess(res.META_TAG || res.res.a.META_TAG || []));
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          dispatch(sessionExpired(err));
        } else {
          dispatch(metaAttachGetUmoDataFailure(err));
        }
        return err;
      });
  };

export const metaCopyRequest = () => ({
  type: actionTypes.META_COPY_REQUEST,
});

export const metaCopySuccess = () => ({
  type: actionTypes.META_COPY_SUCCESS,
});

export const metaCopyFailure = err => ({
  type: actionTypes.META_COPY_FAILURE,
  err,
});

export const metaCopy = (fromUmoID, umoIDList, searchParams, intl) =>
  function metaCopyDispatch(dispatch) {
    dispatch(metaCopyRequest());
    const options = [
      ['ACTION', 'COPY_METADATA'],
      ['MAX_RESULTS', appConfig.advanced.metaCopyMaxItems],
      ['FROM_UMO_ID', fromUmoID],
      ['METATAG_GROUP_EXCEPTIONS', METATAG_GROUP_EXCEPTIONS.join(',')],
    ];

    let searchQuery;
    if (searchParams instanceof SearchParams) {
      searchQuery = searchParams.toSearchQuery();
    } else if (isString(searchParams)) {
      searchQuery = searchParams;
    }

    const umoArray = _.isArray(umoIDList) ? umoIDList : [umoIDList];
    if (searchQuery) {
      options.push(['SEARCH', searchQuery]);
      for (let i = 0; i < umoArray.length; i += 1) {
        options.push(['EXCLUDE_UMO_ID', umoArray[i]]);
      }
    } else {
      // Insert all umos into webservice call
      for (let i = 0; i < umoArray.length; i += 1) {
        options.push(['TO_UMO_ID', umoArray[i]]);
      }
    }

    const promise = piction.request('MNG_METADATA', options).then((res) => {
      if (res.a.COPIED) {
        dispatch(metaCopySuccess(res));
        return res;
      } else if (res.message && res.message.includes(SESSION_EXPIRED_MESSAGE)) {
        dispatch(sessionExpired(res));
        return res;
      }
      dispatch(metaCopyFailure(res));
      console.error('Meta Copy Error: ', res.a.RETURN_MESSAGE);
      return res;
    });

    return promise;
  };
